import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

export const SEVERITY_COLORS = { critical: '#dc2626', warning: '#d97706', info: '#2563eb' };
export const SEVERITY_TONES = { critical: 'red', warning: 'amber', info: 'blue' };
export const SEVERITY_ICONS = { critical: ErrorOutlineIcon, warning: WarningRoundedIcon, info: InfoOutlinedIcon };
